import { useMemo } from 'react';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UILink from 'UIComponents/link/UILink';
import CompatibilityIcon from 'marketplace-ui-common/compatibility/components/CompatibilityIcon';
import { getTierI18nKey } from 'marketplace-ui-common/utils/i18n';
import { useSelector } from 'react-redux';
import { getPricingUrl } from '../../../utils/urls';
// @ts-expect-error untyped dependency
import { getIsCustomer } from '../../../selectors/auth';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureCardCompatibility = ({
  onTrackInteraction,
  missingCompatibilityRequirement
}) => {
  const isCustomer = useSelector(getIsCustomer);
  const {
    compatibilityType,
    requiredPlanHub,
    requiredPlan
  } = useMemo(() => {
    if (missingCompatibilityRequirement === 'USER_CONDITIONAL_SCOPE') {
      return {
        compatibilityType: 'COMPATIBLE_SOME'
      };
    } else if (missingCompatibilityRequirement) {
      return {
        compatibilityType: 'COMPATIBLE_NONE',
        requiredPlanHub: missingCompatibilityRequirement.split('_')[0],
        requiredPlan: missingCompatibilityRequirement
      };
    } else {
      return {
        compatibilityType: 'COMPATIBLE_ALL'
      };
    }
  }, [missingCompatibilityRequirement]);
  return /*#__PURE__*/_jsxs(UIMediaObject, {
    align: "start",
    itemLeft: /*#__PURE__*/_jsx(CompatibilityIcon, {
      compatibilityType: compatibilityType
    }),
    spacing: "extra-small",
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `appMarketplace.detail.overview.integrationFeatures.${compatibilityType}_jsx`,
      options: {
        planName: requiredPlan ? I18n.text(getTierI18nKey(requiredPlan)) : '',
        linkProps: {
          external: true,
          href: getPricingUrl(isCustomer, requiredPlanHub),
          onClick: () => onTrackInteraction('click feature required plan pricing link', {
            section: 'overview',
            value: requiredPlanHub
          })
        }
      },
      elements: {
        Bold: 'b',
        Link: UILink
      }
    }), compatibilityType === 'COMPATIBLE_SOME' ? /*#__PURE__*/_jsx(UIHelpIcon, {
      className: "m-left-1",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.overview.integrationFeatures.COMPATIBLE_SOME_help"
      })
    }) : undefined]
  });
};